import React, { useState } from "react";
import { Container, Row, Col, Form, Card, Button } from "react-bootstrap";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import { FaTimes } from "react-icons/fa";
import validator from "validator";
import { ENV } from "../../config/config";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { useCreateSupporterMutation, useDeleteSupporterMutation } from "../../redux/api";

const SupportersForm = ({ oldSupporter, permissions }) => {
  const [createSupporter, { isLoading: isCreating }] = useCreateSupporterMutation();
  const [deleteSupporterMut, { isLoading: isDeleting }] = useDeleteSupporterMutation();
  const [supporters, setSupporters] = useState([]);


  const [msg, setMsg] = useState({});

  const handleFileChange = (e) => {
    const acceptedExtensions = [".jpg", ".jpeg", ".png"];
    const validFiles = [];
    Array.from(e.target.files).forEach((file) => {
      const fileExtension = "." + file.name.split(".").pop().toLowerCase();
      if (acceptedExtensions.includes(fileExtension)) {
        validFiles.push(file);
      } else {
        toast.error(
          `Invalid file extension for ${
            file.name
          }. Valid extensions are: ${acceptedExtensions.join(", ")}`
        );
      }
    });

    const count = oldSupporter.length + supporters.length;
    const newFiles = validFiles;
    const newSupporters = newFiles.map((file) => ({
      file,
      image: URL.createObjectURL(file),
      url: "",
    }));
    setSupporters([...supporters, ...newSupporters]);
    const dataTransfer = new DataTransfer();
    newFiles.forEach((file) => dataTransfer.items.add(file));
    supporters.forEach((file) => dataTransfer.items.add(file.file));
    e.target.files = dataTransfer.files;
  };

  const handleRemoveImage = (index) => {
    const newSupporters = [...supporters];
    newSupporters.splice(index, 1);
    setSupporters(newSupporters);
  };

  const handleChange = (index, key, value) => {
    const newSupporters = [...supporters];
    newSupporters[index][key] = value;
    setSupporters(newSupporters);

    if (key === "url") {
      const newMsg = { ...msg };
      if (!validator.isURL(value)) {
        newMsg[`url${index}`] = "Invalid URL";
      } else {
        delete newMsg[`url${index}`];
      }
      setMsg(newMsg);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    let isValid = true;
    const newMsg = { ...msg };
    const formData = new FormData();
    supporters.forEach((supporter, index) => {
      if (supporter.file) {
        formData.append("supporterImage", supporter.file);
      }
      if (!validator.isURL(supporter.url)) {
        newMsg[`url${index}`] = "Invalid URL";
        isValid = false;
      }
      formData.append(`supporterUrl${index}`, supporter.url);
    });

    setMsg(newMsg);
    if (isValid) {
      (async () => {
        await createSupporter(formData);
        setSupporters([]);
        setMsg({});
      })();
    }
  };

  const deleteHandler = (catId) => {
    Swal.fire({
      title: "Are you sure you want to delete?",
      html: "If you delete an item, it will lost permanently.",
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: "var(--accent-primary)",
      cancelButtonColor: "var(--accent-danger)",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (result.value) {
        (async () => {
          await deleteSupporterMut(catId);
        })();
      }
    });
  };

  return (
    <>
      {(isCreating || isDeleting) && <FullPageLoader />}
      <Container fluid>
      <Row>
        <Col md="12">
          <Form
            action=""
            className="form-horizontal"
            id="TypeValidation"
            onSubmit={handleSubmit}
          >
            <Card className="table-big-boy p-5">
              {/* Supporters */}
              <Card className="table-big-boy mb-5">
                <Card.Header>
                  <div className="d-block d-md-flex align-items-center justify-content-between">
                    <Card.Title as="h4">Our Supporters</Card.Title>
                  </div>
                </Card.Header>

                <Card.Body>
                  <Form.Group>
                    <Form.Label className="d-block mb-2">
                      Upload Images
                    </Form.Label>
                    <Form.Control
                      type="file"
                      multiple
                      onChange={handleFileChange}
                      accept="image/*"
                    />
                  </Form.Group>
                  <Row>
                    {oldSupporter &&
                      oldSupporter.map((supporter, index) => (
                        <Col
                          xl={4}
                          md={6}
                          key={index}
                          className="position-relative"
                        >
                          <FaTimes
                            onClick={() => deleteHandler(supporter.id)}
                            className="position-absolute"
                            style={{
                              top: "10px",
                              right: "30px",
                              color: "red",
                              fontSize: "1.5rem",
                              cursor: "pointer",
                              zIndex: "999",
                            }}
                          />
                          <img
                            src={ENV.assetsUrl + "setting/" + supporter.image}
                            alt={`Supporter ${index}`}
                            className="img-fluid"
                          />
                          <Form.Group>
                            <Form.Label className="d-block mb-2">
                              URL
                            </Form.Label>
                            <Form.Label className="d-block mb-2">
                              {supporter.url}
                            </Form.Label>
                          </Form.Group>
                        </Col>
                      ))}
                    {supporters.map((supporter, index) => (
                      <Col
                        xl={4}
                        md={6}
                        key={index}
                        className="position-relative"
                      >
                        <FaTimes
                          onClick={() => handleRemoveImage(index)}
                          className="position-absolute"
                          style={{
                            top: "10px",
                            right: "30px",
                            color: "red",
                            fontSize: "1.5rem",
                            cursor: "pointer",
                            zIndex: "999",
                          }}
                        />
                        <img
                          src={supporter.image}
                          alt={`Supporter ${index}`}
                          className="img-fluid"
                        />
                        <Form.Group>
                          <Form.Label className="d-block mb-2">URL</Form.Label>
                          <Form.Control
                            type="text"
                            value={supporter.url}
                            onChange={(e) =>
                              handleChange(index, "url", e.target.value)
                            }
                          />
                          {msg[`url${index}`] && (
                            <span className="text-danger">
                              {msg[`url${index}`]}
                            </span>
                          )}
                        </Form.Group>
                      </Col>
                    ))}
                  </Row>
                </Card.Body>
              </Card>
              <hr className="centered-hr" />

              <Card.Footer>
                <Row className="float-right">
                  {permissions && permissions.editSetting && (
                    <Col sm={12} className="d-flex">
                      <Button
                        className="btn-filled mt-3"
                        type="submit"
                      >
                        Save
                      </Button>
                    </Col>
                  )}
                </Row>
              </Card.Footer>
            </Card>
          </Form>
        </Col>
      </Row>
    </Container>
    </>
  );
};


export default SupportersForm;
